import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Col, Modal, Row, Button } from 'react-bootstrap';
import APICom from '../../utils/helpers/APICom';
import PersistStorage from "../../utils/helpers/PersistStorage";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity.js";
import MapControlSkeleton from '../Controls/mapControlSkeleton';
import GridControl from '../Controls/gridControl';
import ConfirmationModal from '../Controls/ConfirmationModal.js';
import { mainstore } from "../../store";
import Timer from "../Controls/Timer";
import saveIcon from "../../assets/Images/CommonImages/save.png";
import AdjustTimes from "../../assets/Images/CommonImages/adjustTimes.png";
import ValidateIcon from "../../assets/Images/CommonImages/validateIcon.png";
import infoIcon from "../../assets/Images/CommonImages/info.png";
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useDispatch } from "react-redux";
import { addLoginResponse } from "../../features/login/loginSlice";
// let clusterComboData = [];

const RouteSuggestion = (props) => {

    const dispatch = useDispatch();
    const [routeObj, setAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const [showAlert, setAlert] = useState(false);
    const [ShowRouteSuggestionGridLoader, setShowRouteSuggestionGridLoader] = useState(false);
    const { ARBResponseForRouteSuggestionValidate, ARBResponseForRouteSuggestionAdjustTime, ARBResponseForRouteSuggestionNoViolation } = useSelector((store) => store.ARB);
    const { loginData } = useSelector((store) => store.login);
    const { GlobalASCSData, DispatchVehicleData, ASCSSettingData, ZoneVerticesData } = useSelector((store) => store.combinedata);
    const [RouteSuggestionGridData, setRouteSuggestionGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Route Suggestion',
        body: 'An error occured while saving', btnCancelText: 'No', btnOkText: 'Yes'
    }
    );
    const [confirmationModalObj2, setConfirmationModalObj2] = useState({
        show: false, title: 'Manual Stop View Adjustment',
        body: 'No Passenger can stay on-boarded while driver taking break', btnCancelText: 'No', btnOkText: 'Yes'
    }
    );
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalBodyHTML, setModalBodyHTML] = useState("");
    const [modalBtnHTML, setModalBtnHTML] = useState([]);
    const [rowMoveFlag, setRowMoveFlag] = useState(false);
    const [violationColors, setViolationColors] = useState([{
        "capacity": "#FFA500", "timeWindow": "#C6B0F2", "RideTime": "#87CEEB",
        "maxMilesHours": "#BF8B19", "driverBreak": "#91F895",
        "uniqueStops": "#FA7AFC", "nonDrop": "#FF0000", "puLoopBack": "#F5CAA4", "WillCallTrip": "#B2B200", "TripStartTime": "#004d80",
        "MaxTrips": "#00ff3e", "invalidDOGPS": "#000dff", "maxRouteHrs": "#303030", "invalidPUGPS": "#05501e", "RideSharing": "#5d00ff"
    }
    ]);

    const xCancelSourceForGrid = useRef(null);

    const [showLoader, setShowLoader] = useState(false);
    const [SuggestedRoutesData, setSuggestedRoutesData] = useState([]);
    const RefSuggestedRoutesData = useRef(null);
    const iRUnID = props.forceData?.run_id || '';
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [mapData, setMapData] = useState([]);
    const [reArrangedRows, setReArrangedRows] = useState([]);
    const RouteSuggestionTableObject = useRef(null);
    const [NewTripsCount, setNewTripsCount] = useState(0);
    const [SelectedRouteInformationObj, setSelectedRouteInformationObj] = useState(null);
    const [SelectedRouteOldInformationObj, setSelectedRouteOldInformationObj] = useState(null);
    const selectedDate = PersistStorage.retrieve("selectedDate", false);
    const AffiliateID = PersistStorage.retrieve("AffiliateID", false);
    const duration = parseInt(mainstore.getState().configuration.ManifestRouteSuggestionRejectLoaderTime);
    const [isActive, setIsActive] = useState(true);
    const [stopsLoading, setStopsLoading] = useState(false);
    const [SuggestionGridColumnSetting, setSuggestionGridColumnSetting] = useState({});
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isMapOpen, setIsMapOpen] = useState(true);
    const [showExtendWarning, setShowExtendWarning] = useState(false);
    const [timerKey, setTimerKey] = useState(0);

    const [RouteSuggestionTitle, setRouteSuggestionTitle] = useState("Route Suggestion");


    const TotalRoutedTrips = SelectedRouteInformationObj?.TotalRoutedTrips || '0';
    const TotalPassengerCount = SelectedRouteInformationObj?.TotalPassengerCount || '0';
    const WheelChairCount = SelectedRouteInformationObj?.WheelChairCount || '0';
    const AmbulatoryCount = SelectedRouteInformationObj?.AmbulatoryCount || '0';
    const TotalRoutedTime = SelectedRouteInformationObj?.TotalRoutedTime || '0';
    const RouteDuration = SelectedRouteInformationObj?.RouteDuration || '0';
    const TotalRoutedMiles = SelectedRouteInformationObj?.TotalRoutedMiles || '0';
    const IdleTime = SelectedRouteInformationObj?.IdleTime || '0';


    const TotalRoutedTripsOld = SelectedRouteOldInformationObj?.iTotalNoOfTrip || '0';
    const TotalPassengerCountOld = SelectedRouteOldInformationObj?.iTotalPassengerCount || '0';
    const WheelChairCountOld = SelectedRouteOldInformationObj?.iTotalWCCount || '0';
    const AmbulatoryCountOld = SelectedRouteOldInformationObj?.iTotalAmbCount || '0';
    const TotalRoutedTimeOld = SelectedRouteOldInformationObj?.dTotalRouteMinutes || '0';
    const RouteDurationOld = SelectedRouteOldInformationObj?.RouteDuration || '0';
    const TotalRoutedMilesOld = SelectedRouteOldInformationObj?.dTotalRouteMile || '0';
    const CompleteRouteSchMinsOld = SelectedRouteOldInformationObj?.dCompleteRouteSchMins || '0';
    const IdleTimeOld = SelectedRouteOldInformationObj?.IdleTime || '0';


    const [RouteSuggestionGridOptions, setRouteSuggestionGridOptions] = useState({
        height: '100%',
        heightoffset: 105,
        calculateHeight: true,
        pagination: true,
        mapZoomOpts: { zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false },
        mapDefaultBtns: false,
        mapOptions: { tilt: 47.5, zoom: 15, zone: false },
        mapPolylines: { single: false, multiple: true },
        movableRows: true,
        sortCondition: false,
        paginationMode: "local",
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 500, 600],
        selectable: true,
        reactiveData: false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder: "No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName: "RouteSuggestionGrid",
        paginationCounter: "rows",
        movableColumns: true,
        vDefaultGridName: "RouteSuggestionGrid",
        index: "Index",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns: ["Latitude", "Longitude", "Select", "Index", "nTotalPassengerCount", "nTotalWCCount", "RouteID", "ERSASettingID",
            "vManifestNumber", "iTripSourceID", "SortOrder", "HiddenSchTime"],
        containerClass: "col position-relative mt-2",
        Containerstyle: {},
        customWidthCols: [""],
        ActionList: false,
        saveCCSettingsOption: true,
        CCAddition: true,
        ActionRowColoring: true,
        ArrangeClusterTripsErrorCases: [{
            "TripAtTop": "Trip is already at the top.", "TripAtBottom": "Trip is already at the bottom.",
            "PUAfterDO": "Pickup can't come after its Dropoff!", "DOBeforePU": "Dropoff can't come before its Pickup!",
            "PrevRowNotExist": "Action not allowed because no previous row exist", "PrevDepotTrip": "Action not allowed because previous trip is depot trip",
            "PrevWillCallTrip": "Action not allowed because previous trip is a will call trip", "PerformedStops": "Action not allowed because trip has already been performed",
            "PrevPerformedStop": "Action not allowed because previous trip has already been performed",
            "PrevBreakTrip": "Action not allowed because previous trip is a break trip", "NextDepotTrip": "Action not allowed because next trip is depot trip",
            "NextvWillCallTrip": "Action not allowed because next trip is a will call trip", "NextBreakTrip": "Action not allowed because next trip is a break trip",
            "NextPerformedStop": "Action not allowed because next trip has already been performed",
            "CompletedTrip": "Action not allowed because dragged trip has already been performed"
        }],
        tableDoubleClickFunc: function (table, row) {
        },
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
            + "RouteSuggestionGrid" + '_ExportToExcel"></button><button class="tabulator_btns lastTabulator-btn" '
            + ' title="Adjust Time & Validate Route" id="' + "RouteSuggestionGrid" + '_AdjustTimes"></button><button class="tabulator_btns lastTabulator-btn" '
            + ' title="Validate Route" id="' + "RouteSuggestionGrid" + '_Validate"></button><button class="tabulator_btns lastTabulator-btn" '
            + ' title="Display Violations Legend" id="' + "RouteSuggestionGrid" + '_infoViolations"></button>',
        GeneralArrayForHTML: ["Violation"],
        footerElementHandles: function (table) {
            RouteSuggestionTableObject.current = table;

            let allRecords = RouteSuggestionTableObject.current.getData()
            let count = 0;

            if (allRecords !== null) {

                for (var k = 0; k < allRecords.length; k++) {
                    if (allRecords[k]["PUPerson"]?.toLowerCase() !== 'breaktrip') {

                        const nodeType = allRecords[k]["Type"]?.toLowerCase();
                        if (nodeType === "pu" || nodeType === "do") {
                            count++;
                        }

                    }

                }
            }
            setNewTripsCount(count);

            // RouteSuggestionTableObject.current.selectRow( RouteSuggestionTableObject.current.getData()[0].Index);
            var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = saveIcon;
            document.getElementById("RouteSuggestionGrid_ExportToExcel").appendChild(img);

            var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = AdjustTimes;
            document.getElementById("RouteSuggestionGrid_AdjustTimes").appendChild(img);

            var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = ValidateIcon;
            document.getElementById("RouteSuggestionGrid_Validate").appendChild(img);

            var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = infoIcon;
            document.getElementById("RouteSuggestionGrid_infoViolations").appendChild(img);


            document.getElementById("RouteSuggestionGrid_ExportToExcel").addEventListener("click", function () {
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row => {
                    const filteredRow = { ...row };
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });

                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "route_suggestion_stops.xlsx");

            });

            document.getElementById('RouteSuggestionGrid_AdjustTimes').addEventListener("click", async function () {
                AdjustRouteSuggestionTimes();
            });

            document.getElementById('RouteSuggestionGrid_Validate').addEventListener("click", async function () {
                setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please wait...', displayFooter: false });
                setAlert(true);
                ValidateRouteSuggestion();
            });

            document.getElementById('RouteSuggestionGrid_infoViolations').addEventListener("click", function () {
                let manageRouteFooterBtns = ["Close"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                    return (
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                            {item}
                        </Button>
                    );
                });
                let manageBodyHTML = function (index) {
                    return (
                        <Row key={index} className="border rounded p-1">
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Capacity(CV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Time Window(TWV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Ride Time(RTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Miles(MMV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Driver Break(DBV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Unique Stops(USV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].capacity }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].timeWindow }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].RideTime }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].maxMilesHours }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].driverBreak }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].uniqueStops }}></div>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Non Drop(NDV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Pickup Loop Back(PLV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Will Call Trips(WCV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Route Start Time(EST):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Trips(MTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Invalid DO GPS(DGDSV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].nonDrop }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].puLoopBack }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].WillCallTrip }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].TripStartTime }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].MaxTrips }}></div>
                                <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].invalidDOGPS }}></div>
                            </Col>
                            <Row>
                                <Col xs={5}>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Route Hours(RHV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Invalid PU GPS(PGPSV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Ride Sharing(RSV):"}</p>
                                </Col>
                                <Col xs={7} style={{ marginLeft: "-6.0%" }}>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].maxRouteHrs }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].invalidPUGPS }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].RideSharing }}></div>
                                </Col>
                            </Row>
                        </Row>

                    );
                };
                setModalHeaderText("Violations Legend");
                setModalBodyHTML(manageBodyHTML);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowDynamicModal(true);
            });
        },



        rowSelectionChangeHandle: function (data) {
            try {
                // if(data.length > 0)
                // {
                //     // console.log(data);
                //     let actualData = data[0];
                //     let tripLatLng = [];

                //     const nodeType = actualData["Node Type"]?.toLowerCase();
                //     if (nodeType === "pu") {
                //         if(actualData.Latitude && actualData.Latitude !== "" && actualData.Latitude !== 0)
                //             {
                //                 tripLatLng.push({lat:parseFloat(actualData.Latitude),lng: parseFloat(actualData.Longitude), Type:"PU", name:"N/A", address:actualData.Address});
                //             }

                //             else
                //             {
                //                 tripLatLng.push({lat:"",lng: "", Type:"PU", name:"N/A", address:"N/A"});
                //             }

                //     }

                //     else if (nodeType === "do") {
                //         if(actualData.Longitude && actualData.Longitude !== "" && actualData.Longitude !== 0)
                //             {
                //                 tripLatLng.push({lat:parseFloat(actualData.Latitude),lng: parseFloat(actualData.Longitude), Type:"DO", name:"N/A", address:actualData.Address});
                //             }
                //         else
                //             {
                //                 tripLatLng.push({lat:"",lng: "", Type:"DO", name:"N/A", address:"N/A"});
                //             }

                //     }
                //     // console.log(tripLatLng, actualData);
                //     setMapData(tripLatLng);
                // }
            }
            catch (err) { console.log(err); }
        },
    });


    const ValidateRouteSuggestion = async () => {
        // setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...' , displayFooter: false});
        // setAlert(true);


        let StopViewMainData = RouteSuggestionTableObject.current.getData()[1];
        // let routeList = RefSuggestedRoutesData.current;
        // let selectedRoute = routeList.find(route => route.RouteID === StopViewMainData.RouteID);

        // if (selectedRoute && selectedRoute.iTotalNoOfTrip < 1) {
        //     setAlertObj({ ...routeObj, alertTitle: 'Route Suggestion', alertMsg: 'Validation allowed for exisiting routes only' , displayFooter: true});
        //     setAlert(true);
        // }


        const data = RouteSuggestionTableObject.current.getData();
        let _tripDetails = [];
        let _stopOrder = 1;

        for (var i = 0; i < data.length; i++) {
            if ((data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept" || data[i].Type === "StartDept") && data[i].iTripSourceID !== 3) {
                let det = {};
                det.RouteID = data[i].RouteID;
                det.iRefID = data[i]["TripNo"];
                if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = data[i].Type;
                det.SystemScheduleTime = data[i]["Sch Time"];
                det.EstTravelTime = data[i].EstTravelTime;
                det.EstTravelDistance = data[i].EstTravelDistance;
                det.WaitTimeAtLocation = 0;
                //det.isNewNode = false;
                det.PUPerson = data[i].PUPerson;
                det.TripRequestStatus = data[i]["Trip Status"];
                det.ERSASettingName = "";
                det.ERSASettingID = _stopOrder;  //algoSettingId;
                det.Zone = "";
                det.Latitude = data[i].Latitude;
                det.Longitude = data[i].Longitude;
                det.isFeasibleRoute = false;
                det.PickupDateTime = data[i]["Requested Time"];
                det.ManifestNumber = data[i].vManifestNumber;

                if (det.NodeType === "StartDept" && _tripDetails.length === 0) {
                    det.PickupDateTime = data[i + 1]["Requested Time"];
                    det.RouteID = data[i + 1].RouteID;
                }
                _tripDetails.push(det);
                _stopOrder++;
            }
        }


        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        let params = {
            "TripDetails": JSON.stringify(_tripDetails),
            "callBackURL": callBackURL,
            "iMode": 15, // 1 for Validate Route on Cluster Table Grid/Stop View Screen
            "AlgoSetting": String(StopViewMainData.ERSASettingID),   //String(StopViewMainData.iSettingID),
            "RouteNo": String(StopViewMainData.RouteID),
            "iAffiliateID": String(AffiliateID), //StopViewMainData.iATSPID,
            "iUserID": loginData.iUserID,
            "iRunID": iRUnID.toString()
        }

        xCancelSourceForGrid.current = APICom.GenerateSource();
        setShowRouteSuggestionGridLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BulkInputToARB", "post", {}, params, xCancelSourceForGrid.current);
        if (response["data"] !== null && response["data"].length > 0) {
            if (response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                setAlertObj({
                    ...routeObj,
                    alertTitle: 'Affiliate Restricted',
                    alertMsg: response["data"][0].Error,
                    displayFooter: true
                });
                setShowRouteSuggestionGridLoader(false);
            }
        }

    }

    const AdjustRouteSuggestionTimes = async () => {

        let StopViewMainData = RouteSuggestionTableObject.current.getData()[1];
        // let routeList = RefSuggestedRoutesData.current;
        // let selectedRoute = routeList.find(route => route.RouteID === StopViewMainData.RouteID);

        // if (selectedRoute && selectedRoute.iTotalNoOfTrip < 1) {
        //     setAlertObj({ ...routeObj, alertTitle: 'Route Suggestion', alertMsg: 'Time Adjustment allowed for exisiting routes only' , displayFooter: true});
        //     setAlert(true);
        // }

        setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please wait...', displayFooter: false });
        setAlert(true);

        const data = RouteSuggestionTableObject.current.getData();
        let _tripDetails = [];
        let _stopOrder = 1;
        for (var i = 0; i < data.length; i++) {
            if ((data[i].Type === "PU" && data[i]["PUPerson"]?.toLowerCase() == 'breaktrip')) {
                for (var j = 0; j < i; j++) {
                    if ((data[j].Type === "EndDept" || data[j]["Type"] === "StartDept" || data[j]['Type'] == "IdleTime")) {
                        continue;
                    }
                    else {
                        if (data.slice(0, i).filter(x => x.Type === "DO" && x["TripNo"] === data[j]["TripNo"]).length > 0) {
                            continue;
                        }
                        else {
                            setAlert(false);
                            setConfirmationModalObj2((prevState) => ({ ...prevState, show: true }));

                            //alert('no passenger can stay on-boarded while taking break');

                            return;
                        }

                    }
                }
            }
            if ((data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept" || data[i].Type === "StartDept") && data[i].iTripSourceID !== 3) {
                let det = {};
                det.RouteID = data[i].RouteID;
                det.iRefID = data[i]["TripNo"];
                if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = data[i].Type;
                det.SystemScheduleTime = data[i]["Sch Time"];
                det.EstTravelTime = data[i].EstTravelTime;
                det.EstTravelDistance = data[i].EstTravelDistance;
                det.WaitTimeAtLocation = 0;
                //det.isNewNode = false;
                det.PUPerson = data[i].PUPerson;
                det.TripRequestStatus = data[i]["Trip Status"];
                det.ERSASettingName = "";
                det.ERSASettingID = _stopOrder;  //algoSettingId;
                det.Zone = "";
                det.Latitude = data[i].Latitude;
                det.Longitude = data[i].Longitude;
                det.isFeasibleRoute = false;
                det.PickupDateTime = data[i]["Requested Time"];
                det.ManifestNumber = data[i].vManifestNumber;

                if (det.NodeType === "StartDept" && _tripDetails.length === 0) {
                    det.PickupDateTime = data[i + 1]["Requested Time"];
                    det.RouteID = data[i + 1].RouteID;
                }
                _tripDetails.push(det);
                _stopOrder++;
            }
        }
        if (_tripDetails.length === 1) {
            //ShowDialogueMsg("InValid Action", "Action not allowed.");
            return false;
        }

        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        let params = {
            "TripDetails": JSON.stringify(_tripDetails),
            "callBackURL": callBackURL,
            "iMode": 14,
            "AlgoSetting": String(StopViewMainData.ERSASettingID),   //String(StopViewMainData.iSettingID),
            "RouteNo": String(StopViewMainData.RouteID),
            "iAffiliateID": String(AffiliateID), //StopViewMainData.iATSPID,
            "iUserID": loginData.iUserID
        }

        setShowRouteSuggestionGridLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BulkInputToARB", "post", {}, params);
        if (response["data"] !== null && response["data"].length > 0) {
            if (response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                setAlertObj({
                    ...routeObj,
                    alertTitle: 'Affiliate Restricted',
                    alertMsg: response["data"][0].Error,
                    displayFooter: true
                });
                setShowRouteSuggestionGridLoader(false);
            }
        }



    }

    useEffect(() => {
        if (ARBResponseForRouteSuggestionValidate && ARBResponseForRouteSuggestionValidate.length !== null && RouteSuggestionTableObject.current !== null) {
            setShowRouteSuggestionGridLoader(false);
            handleRouteAlertClose();
            handleRouteClick(selectedRoute);
        }
        return () => {
        };
    }, [ARBResponseForRouteSuggestionValidate]);

    useEffect(() => {

        const handleAdjustSaveAndValidate = async () => {
            try {
                await AdjustTimeTempSave();

                await handleRouteClick(selectedRoute);
                // await new Promise((resolve) => setTimeout(resolve, 2000));
                await ValidateRouteSuggestion();


            } catch (error) {
                console.error("Error in handleAdjustAndValidate:", error);
            }
        };

        if (ARBResponseForRouteSuggestionAdjustTime.length != null && RouteSuggestionTableObject.current != null) {
            let _driverBreakStart = null;
            let _driverBreakEnd = null;

            let _tempGridData = RouteSuggestionTableObject.current.getData();
            for (let d = 0; d < _tempGridData.length; d++) {
                if (_tempGridData[d]["Type"] == "DriverBreakStart") {
                    _driverBreakStart = _tempGridData[d];
                } else if (_tempGridData[d]["Type"] == "DriverBreakEnd") {
                    _driverBreakEnd = _tempGridData[d];
                }
            }

            if (_driverBreakEnd != null) {
                RouteSuggestionTableObject.current.deleteRow(_driverBreakEnd.Index);
            }
            if (_driverBreakStart != null) {
                RouteSuggestionTableObject.current.deleteRow(_driverBreakStart.Index);
            }

            let _allRowsGrid2 = RouteSuggestionTableObject.current.getData();
            try {

                for (var k = 0; k < _allRowsGrid2.length; k++) {
                    for (var i = 0; i < ARBResponseForRouteSuggestionAdjustTime.length; i++) {
                        if ((_allRowsGrid2[k].Index === String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "" + ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"])
                            //   || (_allRowsGrid2[k].TripNo === ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"] && _allRowsGrid2[k].Type===ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"])
                        ) {
                            if (ARBResponseForRouteSuggestionAdjustTime[i]["WaitTimeAtLocation"] <= 5) {
                                if (k > 0 && _allRowsGrid2[k - 1]["Type"] == "IdleTime") {
                                    RouteSuggestionTableObject.current.deleteRow(_allRowsGrid2[k - 1].Index);
                                }
                            }
                            if (ARBResponseForRouteSuggestionAdjustTime[i]["WaitTimeAtLocation"] > 5) {
                                let _idleTimeData = {};
                                _idleTimeData["TripNo"] = i + "_";
                                _idleTimeData["Sch Time"] = moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).add(-1, 'minutes').format('HH:mm');
                                _idleTimeData["HiddenSchTime"] = moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).add(-1, 'minutes').format('YYYY-MM-DDTHH:mm:ss')
                                _idleTimeData["Type"] = "IdleTime";
                                _idleTimeData["IdleTime"] = ARBResponseForRouteSuggestionAdjustTime[i]["WaitTimeAtLocation"];
                                _idleTimeData["ERSASettingID"] = _allRowsGrid2[k]["ERSASettingID"];
                                _idleTimeData["RouteID"] = _allRowsGrid2[k]["RouteID"];
                                _idleTimeData["Index"] = i + "_IdleTime";
                                if (k > 0 && _allRowsGrid2[k - 1]["Type"] != "IdleTime") {
                                    //add new row above existing row with index of ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"] + "_" + responseData[i]["NodeType"]
                                    RouteSuggestionTableObject.current.addRow(_idleTimeData, true, ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"] + "" + ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"]);
                                }
                                else {

                                    RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["Sch Time"]: _idleTimeData["SchTime"] });
                                    RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["HiddenSchTime"]: _idleTimeData["HiddenSchTime"] });
                                    RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["IdleTime"]: _idleTimeData["IdleTime"] });


                                }


                            }
                            /*
                            if(_allRowsGrid2[k].Index.includes("BRKS") || _allRowsGrid2[k].Index.includes("BRKE")){

                                if(_allRowsGrid2[k].Index.includes("BRKS")){
                            RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });



                            RouteSuggestionTableObject.current.updateRow(
                                String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS",
                                { ["HiddenSchTime"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss') }
                            );

                            RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                            RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });
                            // RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["Address"]: ARBResponseForRouteSuggestionAdjustTime[i].Address });
                            }
                            else{
                                RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });
                            RouteSuggestionTableObject.current.updateRow(
                                String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE",
                                { ["HiddenSchTime"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss') }
                            );

                            RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                            RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });
                            // RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["Address"]: ARBResponseForRouteSuggestionAdjustTime[i].Address });
                            }
                            }*/
                            else {
                                RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "" +
                                    ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"], { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });



                                RouteSuggestionTableObject.current.updateRow(
                                    String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "" + ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"],
                                    { ["HiddenSchTime"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss') }
                                );

                                RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "" + ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"], { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                                RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "" + ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"], { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });
                            }
                        }

                        else if ((_allRowsGrid2[k].TripNo === ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"] && _allRowsGrid2[k].Type === ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"])) {
                            if (_allRowsGrid2[k].Index.includes("BRKS") || _allRowsGrid2[k].Index.includes("BRKE")) {

                                if (_allRowsGrid2[k].Index.includes("BRKS")) {
                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });



                                    RouteSuggestionTableObject.current.updateRow(
                                        String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS",
                                        { ["HiddenSchTime"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss') }
                                    );

                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });
                                    // RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKS", { ["Address"]: ARBResponseForRouteSuggestionAdjustTime[i].Address });
                                }
                                else {
                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });
                                    RouteSuggestionTableObject.current.updateRow(
                                        String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE",
                                        { ["HiddenSchTime"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss') }
                                    );

                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                                    RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });
                                    // RouteSuggestionTableObject.current.updateRow(String(parseInt(ARBResponseForRouteSuggestionAdjustTime[i]["MVRecordID"])) + "BRKE", { ["Address"]: ARBResponseForRouteSuggestionAdjustTime[i].Address });
                                }
                            }
                        }
                    }

                    if (_allRowsGrid2[k].Type == "StartDept") {
                        for (var i = 0; i < ARBResponseForRouteSuggestionAdjustTime.length; i++) {
                            if (ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"] == "StartDept") {

                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k].Index, { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k].Index, {
                                    ["HiddenSchTime"]:
                                        moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss')
                                });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k].Index, { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k].Index, { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });

                            }
                        }
                    }

                    if (_allRowsGrid2[k].Type == "EndDept") {
                        for (var i = 0; i < ARBResponseForRouteSuggestionAdjustTime.length; i++) {
                            if (ARBResponseForRouteSuggestionAdjustTime[i]["NodeType"] == "EndDept") {

                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "" + _allRowsGrid2[k]["Type"], { ["Sch Time"]: moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('HH:mm') });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "" + _allRowsGrid2[k]["Type"], {
                                    ["HiddenSchTime"]:
                                        moment(ARBResponseForRouteSuggestionAdjustTime[i].SystemScheduleTime).format('YYYY-MM-DDTHH:mm:ss')
                                });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "" + _allRowsGrid2[k]["Type"], { ["EstTravelTime"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelTime });
                                RouteSuggestionTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "" + _allRowsGrid2[k]["Type"], { ["EstTravelDistance"]: ARBResponseForRouteSuggestionAdjustTime[i].EstTravelDistance });

                            }
                        }
                    }
                    let _tempGridStopType = RouteSuggestionTableObject.current.getData()[k]?.Type;
                    let _gridPrvSchTime = "00:00"
                    let _gridPrvSchTimeInMinutes = 0;

                    try {
                        _gridPrvSchTime = RouteSuggestionTableObject.current.getData()[k]["Sch Time"];
                        if (_gridPrvSchTime != undefined) {

                            _gridPrvSchTimeInMinutes = (parseInt(_gridPrvSchTime.split(':')[0]) * 60) + (parseInt(_gridPrvSchTime.split(':')[1]));
                        }
                    } catch (b) {

                    }

                    let _gridSchTime = RouteSuggestionTableObject.current.getData()[k]?.["Sch Time"];
                    let _gridSchTimeInMinutes = 0;

                    if (_gridSchTime != undefined) {

                        _gridSchTimeInMinutes = (parseInt(_gridSchTime.split(':')[0]) * 60) + (parseInt(_gridSchTime.split(':')[1]));
                    }


                    if (_driverBreakStart && _tempGridStopType != "StartDept" && _tempGridStopType != "DriverBreakStart" && _tempGridStopType != "DriverBreakEnd") {
                        let _breakStartSchTime = _driverBreakStart["Sch Time"];
                        let _breakStartSchTimeInMinutes = (parseInt(_breakStartSchTime.split(':')[0]) * 60) + (parseInt(_breakStartSchTime.split(':')[1]));

                        if (_gridSchTimeInMinutes >= _breakStartSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakStartSchTimeInMinutes) {
                            RouteSuggestionTableObject.current.addRow(_driverBreakStart, true, _allRowsGrid2[k].Index);
                            _driverBreakStart = null;
                        }
                    }
                    if (_driverBreakEnd && _tempGridStopType != "StartDept" && _tempGridStopType != "DriverBreakStart" && _tempGridStopType != "DriverBreakEnd") {
                        let _breakEndSchTime = _driverBreakEnd["Sch Time"];
                        let _breakEndSchTimeInMinutes = (parseInt(_breakEndSchTime.split(':')[0]) * 60) + (parseInt(_breakEndSchTime.split(':')[1]));

                        if (_gridSchTimeInMinutes >= _breakEndSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakEndSchTimeInMinutes) {
                            RouteSuggestionTableObject.current.addRow(_driverBreakEnd, true, _allRowsGrid2[k].Index);
                            _driverBreakEnd = null;
                        }
                    }

                }

            }
            catch (err) { console.log(err); }


            try {
                handleAdjustSaveAndValidate();
            } catch (error) {
                console.error("Error in handling adjust save and validate:", error);
            }

            //     AdjustTimeTempSave()

            //    setTimeout(() => {
            //     ValidateRouteSuggestion();
            //   }, 2000);
        }
        return () => { };

    }, [ARBResponseForRouteSuggestionAdjustTime]);

    useEffect(() => {
        if (ARBResponseForRouteSuggestionNoViolation.length != null && RouteSuggestionTableObject.current != null) {
            let allRows = RouteSuggestionTableObject.current.getData();
            // Map over all rows and set the 'Violation' column to an empty string
            let updatedRows = allRows.map(row => ({
                ...row, // Keep the other columns unchanged
                Violation: "" // Update 'Violation' column to an empty string for each row
            }));

            // Now update the table with the new rows
            RouteSuggestionTableObject.current.updateData(updatedRows);

            setShowRouteSuggestionGridLoader(false);
            handleRouteAlertClose();
        }
    }, [ARBResponseForRouteSuggestionNoViolation])


    const AdjustTimeTempSave = async () => {

        let saveSuggestionDataAfterAdjust = RouteSuggestionTableObject.current.getData();

        let tripDetails = [];
        let stopOrder = 1;
        for (var i = 0; i < saveSuggestionDataAfterAdjust.length; i++) {
            if ((saveSuggestionDataAfterAdjust[i].Type === "PU" || saveSuggestionDataAfterAdjust[i].Type === "DO" || saveSuggestionDataAfterAdjust[i].Type === "EndDept" || saveSuggestionDataAfterAdjust[i].Type === "StartDept") && saveSuggestionDataAfterAdjust[i].iTripSourceID !== 3) {
                let det = {};
                det.RouteID = saveSuggestionDataAfterAdjust[i].RouteID;
                det.iRefID = saveSuggestionDataAfterAdjust[i]["TripNo"];
                if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = saveSuggestionDataAfterAdjust[i].Type;
                det.SystemScheduleTime = saveSuggestionDataAfterAdjust[i]["HiddenSchTime"];
                det.EstTravelTime = saveSuggestionDataAfterAdjust[i].EstTravelTime;
                det.EstTravelDistance = saveSuggestionDataAfterAdjust[i].EstTravelDistance;
                det.WaitTimeAtLocation = 0;
                //det.isNewNode = false;
                det.PUPerson = saveSuggestionDataAfterAdjust[i].PUPerson;
                det.TripRequestStatus = saveSuggestionDataAfterAdjust[i]["Trip Status"];
                det.ERSASettingName = "";
                det.ERSASettingID = stopOrder;  //algoSettingId;
                det.Zone = "";
                det.Latitude = saveSuggestionDataAfterAdjust[i].Latitude;
                det.Longitude = saveSuggestionDataAfterAdjust[i].Longitude;
                det.NodeAddress = saveSuggestionDataAfterAdjust[i].Address;
                det.isFeasibleRoute = false;
                if (det.NodeType === "StartDept" && tripDetails.length === 0) {
                    det.RouteID = saveSuggestionDataAfterAdjust[i + 1].RouteID;
                }
                tripDetails.push(det);
                stopOrder++;
            }
        }
        if (tripDetails.length === 1) {
            //ShowDialogueMsg("InValid Action", "Action not allowed.");
            return false;
        }

        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }

        let params = {
            "TripDetails": JSON.stringify(tripDetails),
            "iRunID": iRUnID,
            "selectedDate": selectedDate.toString()
        }

        setShowRouteSuggestionGridLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/SaveTempRoute", "post", {}, params);



    }

    useEffect(() => {
        try {
            const ARBSelectedOption = PersistStorage.retrieve("ARBSelectedOption", false);
            if (ARBSelectedOption == 'ForceScheduling') {
                setRouteSuggestionTitle("Force Route Assignment")
            }
            else {
                setRouteSuggestionTitle("Route Suggestion")
            }
            FetchSuggestedRoutes() //Get Rider information
        }
        catch (err) { console.log(err); }
        return () => {
            props.setGridRefreshPaused(false);
        }
    }, []);

    useEffect(() => {
        try {
            if (props.reArrangedRowsFlag) {
                props.setReArrangeFlag(false);
                let currentTableData = RouteSuggestionTableObject.current.getData();
                setReArrangedRows(currentTableData);
            }
        }
        catch (err) { console.log(err); }
    }, [props.reArrangedRowsFlag]);

    const FetchStops = async (defaultRoute) => {
        try {
            if (defaultRoute) {
                setStopsLoading(true);
                setSelectedRoute(defaultRoute.RouteID);
                let params = {
                    "iRunID": iRUnID.toString(),
                    //"iRunID":"29165",
                    "RouteID": defaultRoute.RouteID.toString(),
                    "selectedDate": selectedDate.toString(),
                    "GridName": "RouteSuggestionGrid",
                    "iUserID": loginData.recordID
                }
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StopsOnRouteSuggestion", "post", { "Content-Type": "application/json" }, params, null);
                if (response.data != null && response.data.StopView.length > 0) {


                    setRouteSuggestionGridData(response.data.StopView);
                    setSuggestionGridColumnSetting(response.data.GridColSettings)

                    //setRouteSuggestionGridData(dataExampleArr);
                    let dataExampleArr = response.data.StopView;
                    let mapArr = [];
                    for (let k = 0; k < dataExampleArr.length; k++) {
                        if (dataExampleArr[k].Type === "PU") {
                            if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                mapArr.push({
                                    lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                    Type: "PU", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address, SchTime: dataExampleArr[k]["Sch Time"],
                                    TripStatus: dataExampleArr[k]["Trip Status"]
                                });
                            }
                        }
                        else if (dataExampleArr[k].Type === "DO") {
                            if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                mapArr.push({
                                    lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                    Type: "DO", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address, SchTime: dataExampleArr[k]["Sch Time"],
                                    TripStatus: dataExampleArr[k]["Trip Status"]
                                });
                            }
                        }
                        else if (dataExampleArr[k].Type.toLowerCase().includes("dept") || dataExampleArr[k].Type.toLowerCase().includes("depot")) {
                            if (dataExampleArr[k].Type.toLowerCase().includes("start")) {
                                if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                    mapArr.push({
                                        lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                        Type: "StartDepot", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address
                                    });
                                }
                            }
                            else if (dataExampleArr[k].Type.toLowerCase().includes("end")) {
                                if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                    mapArr.push({
                                        lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                        Type: "EndDepot", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address
                                    });
                                }
                            }

                        }
                    }
                    setMapData(mapArr);

                    if (response.data.SelectedRouteInfo?.length > 0) {

                        setSelectedRouteInformationObj(response.data.SelectedRouteInfo[0]);

                    }
                    else {
                        setSelectedRouteInformationObj(null);
                    }

                    if (response.data.SelectedRouteOldInfo?.length > 0) {

                        setSelectedRouteOldInformationObj(response.data.SelectedRouteOldInfo[0])

                    }
                    else {
                        setSelectedRouteOldInformationObj(null);
                    }
                }

            }
        }
        catch (err) { console.log(err); }
        finally {
            setStopsLoading(false);
        }
    };

    function getFormatedTime(time) {

        const hours = Math.floor(time / 60);
        const minutes = Math.floor(time % 60);
        const seconds = Math.floor((time * 60) % 60);
        const formattedTime = `${hours}h ${minutes}m`;

        return formattedTime;


    };


    function getManifestNumber(date, routeNo) {
        try {
            const firstPUDate = new Date(date);
            let manifest = firstPUDate.getFullYear().toString();
            manifest += (firstPUDate.getMonth() + 1 < 10) ? "0" + (firstPUDate.getMonth() + 1).toString() : (firstPUDate.getMonth() + 1).toString();
            manifest += (firstPUDate.getDate() < 10) ? "0" + firstPUDate.getDate().toString() : firstPUDate.getDate().toString();
            manifest += routeNo;

            return manifest;
        }
        catch (err) { console.log(err); }
    };

    const FetchSuggestedRoutes = async () => {
        try {
            let params = {
                "iRunID": iRUnID.toString(),
                "selected_date": selectedDate.toString(),
                "affiliate_id": AffiliateID.toString()
                // "iRunID":"29165",
                // "selected_date": '2024-03-05',
                // "affiliate_id": '28'
            }
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/CandidateGroupRouteSuggestion", "post", { "Content-Type": "application/json" }, params, null);
            if (response !== null && response.data.length > 0) {

                let finalResponse = response?.data
                // finalResponse.sort((a, b) => {
                //     if (a.ViolationsCount !== b.ViolationsCount) {
                //         return a.ViolationsCount - b.ViolationsCount;
                //     }
                // })

                // let finalRoutes = finalResponse.filter(item => item?.ViolationsCount < 0);
                // let res = finalRoutes.length > 0 ? finalRoutes : finalResponse;

                setSuggestedRoutesData(finalResponse);
                RefSuggestedRoutesData.current = finalResponse;
                FetchStops(finalResponse[0]);

            }
            else {
                props.setRouteSuggestionDialog(false);
                props.setGridRefreshPaused(false);
            }
        }
        catch (err) { console.log(err); }
    };

    const handleRouteClick = async (RouteID) => {
        try {
            setStopsLoading(true);
            setSelectedRoute(RouteID);
            let params = {
                "iRunID": iRUnID.toString(),
                //"iRunID":"29165",
                "RouteID": RouteID.toString(),
                "selectedDate": selectedDate.toString(),
                "GridName": "RouteSuggestionGrid",
                "iUserID": loginData.recordID
            }
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StopsOnRouteSuggestion", "post", { "Content-Type": "application/json" }, params, null);
            if (response.data != null && response.data.StopView.length > 0) {

                let newStops = response.data.StopView;

                // Merge validation data organically before rendering the grid
                if (ARBResponseForRouteSuggestionValidate && ARBResponseForRouteSuggestionValidate.length > 0) {
                    const getViolationSpan = (violationID) => {
                        const vMap = {
                            "-1": { color: violationColors[0].capacity, text: "CV" },
                            "-2": { color: violationColors[0].timeWindow, text: "TWV" },
                            "-3": { color: violationColors[0].RideTime, text: "RTV" },
                            "-4": { color: violationColors[0].maxMilesHours, text: "MMV" },
                            "-5": { color: violationColors[0].nonDrop, text: "NDV" },
                            "-6": { color: violationColors[0].driverBreak, text: "DBV" },
                            "-7": { color: violationColors[0].puLoopBack, text: "PLV" },
                            "-8": { color: "#000000", text: "TIV" },
                            "-9": { color: violationColors[0].uniqueStops, text: "USV" },
                            "-10": { color: violationColors[0].TripStartTime, text: "EST" },
                            "-11": { color: violationColors[0].maxRouteHrs, text: "RHV" },
                            "-12": { color: violationColors[0].MaxTrips, text: "MTV" },
                            "-13": { color: violationColors[0].invalidPUGPS, text: "PGPSV" },
                            "-14": { color: violationColors[0].invalidDOGPS, text: "DGPSV" },
                            "-15": { color: violationColors[0].WillCallTrip, text: "WCV" },
                            "-16": { color: violationColors[0].RideSharing, text: "RSV" }
                        };
                        const v = vMap[violationID.toString()];
                        return v ? `<span style="background-color: ${v.color};margin: 2px;color:white;">${v.text}</span>` : "";
                    };

                    for (let i = 0; i < newStops.length; i++) {
                        let _violationHtml = "";
                        for (let j = 0; j < ARBResponseForRouteSuggestionValidate.length; j++) {
                            const stop = newStops[i];
                            const validation = ARBResponseForRouteSuggestionValidate[j];

                            const isMatchingTripID = parseInt(stop.Index) === parseInt(validation.TripNo);
                            const isMatchingStopType = stop.Index.includes(validation.StopType) && validation.StopType !== 'DriverBreakStart';
                            const isDriverBreak = validation.StopType === 'DriverBreakStart' || validation.StopType === '"DriverBreakEnd"';

                            if (isMatchingTripID && (isMatchingStopType || isDriverBreak)) {
                                _violationHtml += getViolationSpan(validation.ViolationID);
                            }
                        }
                        if (newStops[i]['Type'] !== "StartDept" && newStops[i]['Type'] !== "IdleTime" && newStops[i]['Type'] !== "EndDept") {
                            newStops[i].Violation = _violationHtml;
                        }
                    }
                }

                setRouteSuggestionGridData(newStops);
                setSuggestionGridColumnSetting(response.data.GridColSettings)
                let dataExampleArr = response.data.StopView;
                let mapArr = [];
                for (let k = 0; k < dataExampleArr.length; k++) {
                    if (dataExampleArr[k].Type === "PU") {
                        if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                            mapArr.push({
                                lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                Type: "PU", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address, TripStatus: dataExampleArr[k]["Trip Status"]
                            });
                        }
                    }
                    else if (dataExampleArr[k].Type === "DO") {
                        if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                            mapArr.push({
                                lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                Type: "DO", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address, TripStatus: dataExampleArr[k]["Trip Status"]
                            });
                        }
                    }
                    else if (dataExampleArr[k].Type.toLowerCase().includes("dept")) {
                        if (dataExampleArr[k].Type.toLowerCase() === "startdept") {
                            if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                mapArr.push({
                                    lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                    Type: "StartDept", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address
                                });
                            }
                        }
                        else if (dataExampleArr[k].Type.toLowerCase() === "enddept") {
                            if (dataExampleArr[k].Latitude && dataExampleArr[k].Latitude !== "" && dataExampleArr[k].Latitude !== 0) {
                                mapArr.push({
                                    lat: parseFloat(dataExampleArr[k].Latitude), lng: parseFloat(dataExampleArr[k].Longitude),
                                    Type: "EndDept", name: dataExampleArr[k]["PUPerson"], address: dataExampleArr[k].Address
                                });
                            }
                        }

                    }
                }
                setMapData(mapArr);

                if (response.data.SelectedRouteInfo?.length > 0) {

                    setSelectedRouteInformationObj(response.data.SelectedRouteInfo[0]);

                }
                else {
                    setSelectedRouteInformationObj(null);
                }

                if (response.data.SelectedRouteOldInfo?.length > 0) {

                    setSelectedRouteOldInformationObj(response.data.SelectedRouteOldInfo[0])

                }
                else {
                    setSelectedRouteOldInformationObj(null);
                }
            }
        }
        catch (err) { console.log(err); }

        finally {
            setStopsLoading(false);
        }
    }


    const handleCloseRouteSuggestion = () => {

        try {
            if (props.showRouteSuggestionDialog) {
                const newLoginData = {
                    ...loginData, // Spread the existing properties of loginData
                    BuildManifestDispatchID: false, // Update the specific field
                };
                dispatch(addLoginResponse(newLoginData));
                props.setRouteSuggestionDialog(false);
                props.handleCloseOnlyMessageDialog();
                props.setGridRefreshPaused(false);
            }
        }
        catch (err) { console.log(err); }
    };

    const handleRejectChanges = async () => {
        try {
            if (isActive)
                setIsActive(false);
            let params = {
                "run_id": parseInt(iRUnID)
            }

            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/RejectSuggestedRoute", "post",
                { "Content-Type": "application/json" }, params, null);
            if (response !== null && response.data !== null && response.data.msg !== null && response.data.msg !== '') {
                setConfirmationModalObj((prevState) => ({
                    ...prevState, show: true, title: 'Route Suggestion',
                    body: 'An Error Occured while Rejecting', btnOkText: 'Ok'
                })
                );
                props.handleCloseOnlyMessageDialog();
            }
            else {
                handleCloseRouteSuggestion();

            }
            const newLoginData = {
                ...loginData, // Spread the existing properties of loginData
                BuildManifestDispatchID: false, // Update the specific field
            };
            dispatch(addLoginResponse(newLoginData));
            props.setGridRefreshPaused(false);
        }
        catch (err) { console.log(err); }
    };



    const handleSaveRouteSuggestion = async () => {
        try {
            const hasForceAssignAccess = ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ForceAssign");
            const currentlySelectedRouteData = SuggestedRoutesData.find(r => r.RouteID === selectedRoute);
            if (currentlySelectedRouteData && currentlySelectedRouteData.ViolationsCount > 0 && !hasForceAssignAccess) {
                setAlertObj({ ...routeObj, alertTitle: 'Access Restricted', alertMsg: 'You do not have permission to Force Assign a route with violations.', displayFooter: true });
                setAlert(true);
                return;
            }

            const isValidOrder = validateOrder()
            if (!isValidOrder) {
                setAlertObj({ ...routeObj, alertTitle: 'Route Suggestion', alertMsg: 'Please adjust your stop schedule times before accepting.', displayFooter: true });
                setAlert(true);
                return;
            }

            if (isActive) {
                setIsActive(false);

            }
            setLoading(true);
            setAlertObj({ ...routeObj, alertTitle: 'Route Suggestion', alertMsg: 'Saving Route...', displayFooter: false });
            setAlert(true);
            let vManifestNumber = getManifestNumber(selectedDate, selectedRoute)
            let params = {
                "run_id": parseInt(iRUnID),
                "route_no": selectedRoute,
                "user_id": loginData.iUserID,
                "app_id": 26,
                "manifestNumber": vManifestNumber,
                "is_route_suggestion": true

            }
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/AcceptSuggestedRoute",
                "post", { "Content-Type": "application/json" }, params, null);

            let acceptResponseData = response !== null ? response.data : null;
            if (typeof acceptResponseData === 'string') {
                try {
                    acceptResponseData = JSON.parse(acceptResponseData);
                } catch (e) {
                    console.error("Failed to parse AcceptSuggestedRoute response:", e);
                }
            }

            if (response !== null && acceptResponseData !== null && acceptResponseData.msg !== null && acceptResponseData.msg !== '') {
                setLoading(false);
                setAlert(false);
                setConfirmationModalObj((prevState) => ({
                    ...prevState, show: true, title: 'Route Suggestion',
                    body: acceptResponseData.msg, btnOkText: 'Ok',
                    isValidationError: true
                })
                );
                props.handleCloseOnlyMessageDialog();

            }
            else {
                setAlert(false)
                handleCloseRouteSuggestion();
                const newLoginData = {
                    ...loginData, // Spread the existing properties of loginData
                    BuildManifestDispatchID: false, // Update the specific field
                };
                dispatch(addLoginResponse(newLoginData));
                props.setGridRefreshPaused(false);
            }
        }
        catch (err) { console.log(err); }
    };

    const validateOrder = () => {
        let allRows = RouteSuggestionTableObject.current.getData();
        allRows = allRows.filter(row => row.Type !== 'IdleTime');
        for (let i = 0; i < allRows.length - 1; i++) {

            if (allRows[i].bPerformed !== true) {

                // const [currentHours, currentMinutes] = allRows[i]["Sch Time"].split(":").map(Number);
                // const [nextHours, nextMinutes] = allRows[i + 1]["Sch Time"].split(":").map(Number);

                // // Convert time to minutes since midnight
                // const currentSchTime = currentHours * 60 + currentMinutes;
                // const nextSchTime = nextHours * 60 + nextMinutes;

                // if (nextSchTime < currentSchTime) {
                //     return false; // Invalid order
                // }

                const currentSchTime = new Date(allRows[i]["HiddenSchTime"]);
                const nextSchTime = new Date(allRows[i + 1]["HiddenSchTime"]);

                // Check if the next schedule time is earlier than the current one
                if (nextSchTime < currentSchTime) {
                    return false; // Invalid order
                }

            }
        }
        return true; // Valid order
    };

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
        if (!confirmationModalObj.isValidationError) {
            handleCloseRouteSuggestion();
        }
    };
    const handleConfirmationModalOk2 = () => {
        setConfirmationModalObj2((prevState) => ({ ...prevState, show: false }));
    };

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    };
    const handleConfirmationModalClose2 = () => {
        setConfirmationModalObj2((prevState) => ({ ...prevState, show: false }));
    };


    const handleRouteAlertClose = () => {
        // const newLoginData = {
        //     ...loginData, // Spread the existing properties of loginData
        //     BuildManifestDispatchID:false, // Update the specific field
        //   };
        // dispatch(addLoginResponse(newLoginData));
        setAlert(false);
    }

    let SuggestedRouteLimit = parseInt((ASCSSettingData[parseInt(AffiliateID)] ? (JSON.parse(ASCSSettingData[parseInt(AffiliateID)]).find((item) => item.SubTitle === "SuggestedRouteLimit")).value : ""));
    const [showAll, setShowAll] = useState(SuggestedRouteLimit == 0);
    const visibleRoutes = showAll
        ? SuggestedRoutesData
        : SuggestedRoutesData.slice(0, SuggestedRouteLimit);

    return (
        <>
            {showDynamicModal ?
                <Modal centered backdrop="static" keyboard={true} onHide={() => setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalBodyHTML}</Modal.Body>
                    <Modal.Footer>
                        {modalBtnHTML}
                    </Modal.Footer>
                </Modal>
                : ""}
            {showAlert &&
                <Modal centered keyboard={false} show={showAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                    <Modal.Header>
                        <Modal.Title>{routeObj.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{routeObj.alertMsg}</b></Modal.Body>
                    {routeObj.displayFooter ?
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleRouteAlertClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                        : ""}
                </Modal>}
            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} btnOkText={confirmationModalObj.btnOkText} onClose={handleConfirmationModalClose} ShowCancelButton="false" />
            <ConfirmationModal show={confirmationModalObj2.show} Title={confirmationModalObj2.title} Body={confirmationModalObj2.body}
                onOk={handleConfirmationModalOk2} btnOkText={confirmationModalObj2.btnOkText} onClose={handleConfirmationModalClose2} ShowCancelButton="false" />
            {
                props.showRouteSuggestionDialog ?
                    <Modal centered backdrop="static" dialogClassName="modal-route-suggestion-w" keyboard={true} show={props.showRouteSuggestionDialog} onHide={handleRejectChanges} animation={true}>
                        <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none' closeButton>
                            <Modal.Title className='w-100 text-center '>
                                {RouteSuggestionTitle}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='user-select-none py-0'>
                            <Row className="w-100 m-0" style={{ minHeight: "750px" }}>
                                {isSidebarOpen && (
                                    <Col xs={4} className="text-left m-0 pe-2 pb-2">
                                        <p className='border-bottom m-0 fw-bold'>Routes</p>
                                        <div className='' style={{ height: '485px', overflowY: 'auto', overflowX: 'hidden' }}>
                                            <Row>
                                                {visibleRoutes.map(routeData => (
                                                    <Row
                                                        key={routeData.RouteID}
                                                        className={`mt-3 small`}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleRouteClick(routeData.RouteID)}
                                                    >
                                                        <Col xs={1}>
                                                            <span className="material-symbols-outlined">pin_drop</span>
                                                        </Col>
                                                        <Col
                                                            xs={10}
                                                            className={`name driverAlertSelection ${selectedRoute === routeData.RouteID ? "selected-route" : ""
                                                                } ${routeData.iTotalNoOfTrip === 0 ? "new-route" : ""}`}
                                                            style={{ marginLeft: "10px" }}
                                                            title={`Violations Count - ${routeData.ViolationsCount} | Trip Count - ${routeData.iTotalNoOfTrip} | Route Start Time - ${routeData.RouteStartTime} | Total Route Miles - ${routeData.iTotalDistMile} | Total Route Time - ${getFormatedTime(routeData.dCompleteRouteSchMins)}`}
                                                        >
                                                            <p className="m-0" style={{ fontWeight: "bold" }}>
                                                                {routeData.RouteID}
                                                            </p>
                                                            <p className="m-0">
                                                                <span className="text-danger"> {routeData.ViolationsCount}</span> |
                                                                <span> {routeData.iTotalNoOfTrip}</span> |
                                                                <span> {routeData.RouteStartTime}</span> |
                                                                <span> {routeData.iTotalDistMile} mi</span> |
                                                                <span> {getFormatedTime(routeData.dCompleteRouteSchMins)}</span>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                ))}
                                            </Row>
                                            {SuggestedRouteLimit > 0 && SuggestedRoutesData.length > SuggestedRouteLimit && (
                                                <div className="text-center mt-3">
                                                    <Button variant="link" onClick={() => setShowAll(!showAll)}>
                                                        {showAll ? "Show Less" : "Show All"}
                                                    </Button>
                                                </div>
                                            )}

                                            {props.showViolationString && (
                                                <Row className="violation-section mt-3">
                                                    <Col xs={12}>
                                                        {/* Title for the Violation Section */}
                                                        <div className="violation-title" style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '10px' }}>
                                                            <span>Violation Details</span>
                                                        </div>

                                                        {/* Scrollable Violation Message Container */}
                                                        <div
                                                            className="violation-message"
                                                            style={{
                                                                padding: '10px',
                                                                backgroundColor: '#f8d7da',
                                                                borderRadius: '4px',
                                                                maxHeight: '200px', // Adjust as needed
                                                                overflowY: 'auto',   // Enable vertical scrolling if content overflows
                                                                color: '#721c24',
                                                                fontSize: '14px'
                                                            }}
                                                        >
                                                            <p
                                                                className="m-0"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: props.forceData?.violation_string.replace(/\r?\n/g, '<br />') || "No violations found.",
                                                                }}
                                                            />

                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                        </div>


                                        <p className='border-bottom m-0 fw-bold'>Route Summary Info (Current / New)</p>
                                        <div style={{ height: '190px' }}>
                                            <Row style={{ fontSize: "small" }}>
                                                <Col>
                                                    <strong>Total Routed Trips</strong>
                                                    <p> {TotalRoutedTripsOld} / {TotalRoutedTrips}</p>
                                                </Col>
                                                <Col title={`Sum of travel distances from first service stop to last service stop`}>
                                                    <strong>Route Travel Miles</strong>
                                                    <p> {TotalRoutedMilesOld} Miles / {TotalRoutedMiles} Miles</p>
                                                </Col>

                                            </Row>
                                            <Row style={{ fontSize: "small" }}>
                                                <Col title={`Sum of travel time from first service stop to last service stop`}>
                                                    <strong>Route Travel Time</strong>
                                                    <p> {getFormatedTime(TotalRoutedTimeOld)} / {getFormatedTime(RouteDuration)}</p>
                                                </Col>
                                                <Col title={`Sum of all passengers on the Route (Ambulatory/Wheelchair)`}>
                                                    <strong>Total Passengers</strong>
                                                    <p>
                                                        <span className="material-symbols-outlined">accessible</span> {WheelChairCountOld}/{WheelChairCount}
                                                        <span className="material-symbols-outlined">boy</span>{AmbulatoryCountOld}/{AmbulatoryCount}
                                                    </p>
                                                </Col>
                                            </Row>
                                            <Row style={{ fontSize: "small" }}>
                                                <Col title={`Time difference between End Depot to Start Depot`}>
                                                    <strong>Route Duration</strong>
                                                    <p className="m-0"> {getFormatedTime(CompleteRouteSchMinsOld)} / {getFormatedTime(TotalRoutedTime)}</p>
                                                </Col>
                                                <Col>
                                                    <strong>Idle Time</strong>
                                                    <p className="m-0"> {getFormatedTime(IdleTimeOld)} / {getFormatedTime(IdleTime)}</p>
                                                </Col>
                                            </Row>
                                        </div>


                                    </Col>
                                )}
                                <Col xs={isSidebarOpen ? 8 : 12} className={`text-left`} style={{ minWidth: 0, overflowX: "hidden", minHeight: "750px" }}>
                                    <p className='m-0 text-left border-bottom fw-bold d-flex align-items-center justify-content-between'>
                                        <div className="d-flex align-items-center">
                                            <button
                                                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                                                className="btn btn-sm p-0 me-2 text-dark"
                                                title={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
                                                style={{ boxShadow: 'none', border: 'none', background: 'transparent' }}
                                            >
                                                <span className="material-symbols-outlined fs-5" style={{ verticalAlign: 'middle' }}>
                                                    {isSidebarOpen ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right'}
                                                </span>
                                            </button>
                                            Map View
                                        </div>
                                        <button
                                            onClick={() => setIsMapOpen(!isMapOpen)}
                                            className="btn btn-sm p-0 text-dark"
                                            title={isMapOpen ? "Collapse Map" : "Expand Map"}
                                            style={{ boxShadow: 'none', border: 'none', background: 'transparent' }}
                                        >
                                            <span className="material-symbols-outlined fs-5" style={{ verticalAlign: 'middle' }}>
                                                {isMapOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                            </span>
                                        </button>
                                    </p>
                                    {isMapOpen && (
                                        <Row className='m-0 mt-1' style={{ height: "350px" }}>
                                            <Col className="p-0">
                                                <MapControlSkeleton zones={ZoneVerticesData.Table}
                                                    MapDetailData={mapData} options={RouteSuggestionGridOptions}
                                                    DispatchVehicleData={DispatchVehicleData} reArrangedRows={reArrangedRows}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    <p className='text-left m-0 border-bottom fw-bold'>Stops</p>

                                    {stopsLoading ? (

                                        <Row

                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '30%',
                                                height: '300px',
                                            }}
                                            className="loader"></Row>

                                    ) :

                                        (
                                            <Row className="m-0 mt-1" style={{ height: isMapOpen ? "350px" : "700px" }}>
                                                <Col className="p-0 h-100">
                                                    <GridControl ShowLoader={ShowRouteSuggestionGridLoader} Data={RouteSuggestionGridData} options={RouteSuggestionGridOptions}
                                                        setReArrangeFlag={props.setReArrangeFlag} setRowMoveFlag={setRowMoveFlag} GridColumnSetting={SuggestionGridColumnSetting}
                                                        is_route_suggestion={true} height="100%" />
                                                </Col>
                                            </Row>
                                        )}
                                </Col>

                            </Row>

                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-between">
                            <Row className="align-items-center">
                                {/* <div className="d-flex align-items-center me-2">
                        <span className="me-2 fw-bold" style={{ marginRight: "20px !important"}} >New Route  </span>
                        <div title="New Route" style={{ height: "20px", width: "20px", background: "#d3df8b" }}></div>
                    </div> */}
                                <div className="d-flex align-items-center me-2">
                                    <span className="me-2 fw-bold">New Route / New Trip</span>
                                    <div title="New Route / New Trip" style={{ height: "20px", width: "20px", background: "#8CF68C" }}></div>
                                </div>
                            </Row>


                            <div className="d-flex align-items-center">
                                <p className="m-0 me-2 user-select-none fw-bold">Auto Rejection in</p>
                                <Timer key={timerKey} isActive={isActive && (!showExtendWarning)} duration={duration} onExpire={() => setShowExtendWarning(true)} />
                                <Button variant="dark" className="border-0 ms-2" 
                                    onClick={handleSaveRouteSuggestion} 
                                    disabled={loading || (SuggestedRoutesData.find(r => r.RouteID === selectedRoute)?.ViolationsCount > 0 && !ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ForceAssign"))}
                                    title={SuggestedRoutesData.find(r => r.RouteID === selectedRoute)?.ViolationsCount > 0 && !ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ForceAssign") ? "You don't have necessary rights" : ""}
                                >
                                    Accept
                                </Button>
                                <Button variant="dark" className="border-0 ms-2" onClick={handleRejectChanges} disabled={loading}>
                                    Reject
                                </Button>
                            </div>

                        </Modal.Footer>

                    </Modal>
                    : ""}

            {/* Session Extension Warning Modal */}
            <Modal show={showExtendWarning} onHide={handleRejectChanges} centered backdrop="static" keyboard={false} style={{ zIndex: 1060 }}>
                <Modal.Header className="text-white activate_dialog_header_bgcolor border-0">
                    <Modal.Title className="w-100 text-center fw-bold" style={{ fontSize: "1.1rem" }}>Session Expiring</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4 bg-light">
                    <h5 className="mb-3">Your route adjustment time will elapse shortly!</h5>
                    <p className="mb-3 text-muted">Would you like to extend for another {duration ? Math.max(1, Math.round(duration / 60)) : 5} minutes?</p>
                    <div className="d-flex justify-content-center align-items-center mt-4 p-2 rounded border border-danger bg-white shadow-sm" style={{ maxWidth: '250px', margin: '0 auto' }}>
                        <span className="me-2 fw-bold text-danger">Auto-rejecting in:</span>
                        <Timer isActive={showExtendWarning} duration={15} onExpire={handleRejectChanges} />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center border-0 bg-light pt-0">
                    <Button variant="danger" className="px-4 me-2 border-0" onClick={handleRejectChanges}>
                        No, Reject Now
                    </Button>
                    <Button variant="success" className="px-4 ms-2 border-0" onClick={() => {
                        setShowExtendWarning(false);
                        setTimerKey(prev => prev + 1);
                    }}>
                        Yes, Extend Time
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default RouteSuggestion;